import { Injectable } from '@angular/core';
import { environment}  from '../../../environments/environment';
import { StompService } from 'ng2-stomp-service';
import { Subject } from 'rxjs/Subject';
import { isNullOrUndefined } from 'util';
import { Observable } from 'rxjs/Observable';
import { TicketView } from '../../+tickets/ticket.service';
import { TokenManager } from '../../+login/auth.service';
import * as sockJS from 'sockjs-client';
import * as Stomp from 'stompjs';
import * as SockJS from 'sockjs-client';

@Injectable()
export class WebSocketService {
    public _isConnected: boolean = false;
    private _onTicketMessage: Subject<TicketMessage> = new Subject();
    private _onTrackingMessage: Subject<any> = new Subject();
    private _onStatusMessage: Subject<ConnectionStatusMessage> = new Subject();
    public _queues: Array<QueueConnection> = [];
    private connectionInterval = null;

    constructor(private _stompService: StompService) {
        setTimeout(() => this.connectSocket(), 4000);
    }

    // esta conecta con el socket
    public respuestaSocket: any;
    connectSocket() {
        let token = <TokenManager>JSON.parse(localStorage.getItem('auth_token'));
        if (!isNullOrUndefined(token)) {
            this._stompService.configure({
                debug: true,
                host: environment.socket_url + '?access_token=' + token.access_token,
                queue: { 'init': false },
                headers: { 'hier_token': token.hier_token },
                recTimeout: 90000
            });

           this.respuestaSocket =  this._stompService.startConnect()
                .then(() => {
                    this._isConnected = true;
                    // console.log(this._isConnected, 'Entro a conexion socket');
                    this.connectQueues();
                    if (!isNullOrUndefined(this.connectionInterval)) {
                        clearInterval(this.connectionInterval);
                        this.connectionInterval = null;
                    }
                    // console.log('resultado del stomp status:', this._stompService.status);
                }).catch(error => {
                    this._isConnected = false;
                    // console.log(this._isConnected, 'NO Entro a conexion socket');
                    console.error(error);
                    
                    setTimeout(() => { this.connectSocket(); }, 20000);
                });
           // console.log('resultado del socket', this.respuestaSocket);
        }
    }

    disconnectSocket(){
        if (this._isConnected){
            let promise = this._stompService.disconnect();
            this._isConnected = false;
            console.log('status despued de deconectar:', this._stompService.status);
        }
    }
    // public _stompClient : any;
    // verifyConnection(){
    //     console.log('verificar si esta conectado:', this._stompService.status);
    //     // this._stompService.status === 'cone';
    //     let token = <TokenManager>JSON.parse(localStorage.getItem('auth_token'));
    //     let config = {
    //         debug: false,
    //         host: environment.socket_url + '?access_token=' + token.access_token,
    //         queue: { 'init': false },
    //         headers: { 'hier_token': token.hier_token },
    //         recTimeout: 90000
    //     };
    //     // this.respuestaSocket = this._stompService.over
    //     let socket = new SockJS(config.host);
    //     this._stompClient = Stomp.over(socket); // configuracion a traves de stomp
    //
    //     this._stompClient.onWebSocketClose = () => {
    //         this._isConnected = false;
    //         console.log('lo que contiene el cliente:', this._stompClient);
    //         // this.connecting = false;
    //         // this.socketConnectionStatus.next(false);
    //         // if (this.networkService.connected && !this.noReconnect) {
    //         //     this.reconnectStomp();
    //         // }
    //     };
    // }

    connectQueue(queue: QueueConnection) {
        let q = this._queues.find(p => p.idUserApp == queue.idUserApp && p.typeSuscription == queue.typeSuscription);
        // console.log('encontrado o no', q);
        // console.log('is conected o no', this._isConnected);

        if (isNullOrUndefined(q) && this._isConnected) {
            // console.log(queue);
            var headersSuscribe = {
                hier_token: queue.hier_token,
                typeSuscription: queue.typeSuscription,
                idUser: queue.idUserApp
            };
            queue.subscription = this._stompService.subscribe(queue.uri, (response) => {
                // console.log('Respuesta directa del socket' + JSON.stringify(response));

                switch (queue.typeSuscription) {
                    case QueueType.Status:
                        let messages: Array<any> = response.payload;
                        messages.forEach(m => {
                            this._onStatusMessage.next(new ConnectionStatusMessage(queue.username, m.content));
                        });
                        break;
                    case QueueType.Tickets:
                        messages = response.payload;
                        messages.forEach(m => {
                            this._onTicketMessage.next(new TicketMessage(queue.username, m.code, m.content));
                        });
                        break;
                    case QueueType.Tracking:
                        messages = response.payload;
                        messages.forEach(g => this._onTrackingMessage.next(new GpsMessage(
                            g.content.latitud,
                            g.content.longitud,
                            g.content.createdDate,
                            g.content.speed,
                            g.content.username
                        )));
                        break;
                }
            }, headersSuscribe);
            this._queues.push(queue);
            // console.log(this._queues, 'datos');

        }
    }

    connectQueues() {
        this._queues.forEach(q => this.connectQueue(q))
    }

    // removeQueue(id: string) {
    //     this._queues.find(q => q.id == id).subscription.unsubscribe();
    //     this._queues = this._queues.filter(q => q.id != id);
    // }

    removeQueue(idUser: string, typeSuscription: number) {
        let token = <TokenManager>JSON.parse(localStorage.getItem('auth_token'));
        let headersUnsuscribe = {
            hier_token: token.hier_token,
            typeSuscription: typeSuscription,
            idUser: idUser
        };
        console.log(this._queues);
        try {
            this._queues.find(q => q.idUserApp == idUser).subscription.unsubscribe(headersUnsuscribe);
            this._queues = this._queues.filter(q => q.idUserApp != idUser);
            if (this._queues.length == 0) {
                this._queues = [];
            }
        } catch (error) { }

    }

    removeQueueAll(){
        let token = <TokenManager>JSON.parse(localStorage.getItem('auth_token'));
        let contador = 0;
        if (this._queues.length > 0){
            this._queues.forEach(element => {
                if (contador == this._queues.length - 1){
                    // console.log(this._queues);
                    this._queues = [];
                    // console.log(this._queues);
                }else{
                    // var headersUnsuscribe = {
                    //     hier_token: token.hier_token,
                    //     typeSuscription: element.typeSuscription,
                    //     idUser: element.idUserApp
                    // };
                    // console.log('elemento que saca header', headersUnsuscribe);
                    // var hdrs = {id: element.id,
                    // headers: {
                    //     hier_token: token.hier_token,
                    //         typeSuscription: element.typeSuscription,
                    //         idUser: element.idUserApp
                    // }};

                    try {
                       element.subscription.unsubscribe(element.id);

                       // element.unsubscribe(hdrs);
                       // element.unsubscribe();
                    } catch (error) { }
                    contador ++;
                }
            });
        }else{
            this._queues = [];
        }
    }

    get onStatusMessage(): Observable<ConnectionStatusMessage> {
        return this._onStatusMessage.asObservable();
    }

    get onTrackingMessage(): Observable<GpsMessage> {
        return this._onTrackingMessage.asObservable();
    }

    get onTicketMessage(): Observable<TicketMessage> {
        return this._onTicketMessage.asObservable();
    }
}

export class QueueConnection {
    id: string;
    uri: string;
    hier_token:any;
    typeSuscription: QueueType;
    subscription:any;
    idUserApp:any;
    username:any;
}

export class ConnectionStatusMessage {
    constructor(public  username: string,
                public status: string) {
    }
}

export enum QueueType {
    Status = 1,
    Tracking = 2,
    Tickets = 3,
}

export class GpsMessage {
    constructor(public latitud: number,
                public longitud: number,
                public  createdDate: Date,
                public speed: number,
                public username: string) {
    }
}

export class TicketMessage {
    constructor(public username: string,
                public code: string,
                public ticket: TicketView) {
    }
}
